<ul class="layout-menu">
  <ng-container *ngFor="let item of model; let i = index">
    @if (!item.separator) {
      <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
    } @else {
      <li class="menu-separator"></li>
    }
  </ng-container>
</ul>
